import React from 'react';
import ajax from '../../utils/ajax';
import dictionary from '../../utils/dictionary';
import ActivityLoader from './ActivityLoader';
import AlertError from './AlertError';
import TextInput from './TextInput';

class PopNewAmount extends React.Component {

    state = {
        amount: '',
        info: '',
        searchList: false,
        buttonLabel: this.props.buttonLabel || "Confirm Amount",
        loading: false
    }

    onChangeAmount = (event) => {
        this.setState({ amount: event.target.value });
    }

    onConfirm = (event) => {
        event.preventDefault();
        if (this.state.amount.length > 0) {
            this.setState({
                loading: true
            })
            this.props.onConfirm(this.state.amount);
        } else {
            this.setState({
                info: <AlertError message={dictionary._requireAmount} />
            })
        }
    }



    render() {
        return (
            <div className="modal" id="modal_amount_input">
                <div className="modal-dialog modal-dialog-centered" role="document">


                    <div className="modal-content modal-content-demo shadow">
                        <div className="modal-header">
                            <h6 className="modal-title">{this.props.title}</h6>
                            <button aria-label="Close" className="close" data-dismiss="modal" type="button"><span aria-hidden="true">&times;</span></button>
                        </div>
                        <div className="modal-body">
                            {this.state.info}
                            <form method="post" onSubmit={this.onConfirm}>

                                <TextInput
                                    label="Enter Amount"
                                    type="number"
                                    onChange={() => this.onChangeAmount}
                                    value={this.state.amount}
                                />

                            </form>

                            {this.props.description}


                        </div>
                        <div className="modal-footer">
                            {!this.state.loading && <>
                                <button className="btn ripple btn-primary" type="button" onClick={this.onConfirm}>{this.state.buttonLabel}</button>
                                <button className="btn ripple btn-secondary" type="button" data-dismiss="modal">Close</button>
                            </>}

                            {this.state.loading && <ActivityLoader />}
                        </div>
                    </div>


                </div>
            </div>
        )


    }
}

export default PopNewAmount;
